import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { VioTablesModule } from 'vio-tables';
import { TABLE_CONFIG, TABLE_HEADER } from '../../../../node_modules/vio-tables/lib/Interfaces/commonInterfaces';
import { CommonFunctionService } from '../../services/common-function.service';
import { ApiRequestsService } from '../../services/api-requests.service';
import { DisableWhileDirective } from '../../shared/directives/disable-while.directive';

enum CONSTS {
  ALL_DEVICES = '--All--'
}
@Component({
  selector: 'app-data-table-list',
  standalone: true,
  imports: [NgbModule, NgbDropdownModule, VioTablesModule, CommonModule, FormsModule, DisableWhileDirective],
  templateUrl: './data-table-list.component.html',
  styleUrl: './data-table-list.component.scss'
})
export class DataTableListComponent implements OnInit {
  datatableConfig: TABLE_CONFIG = {
    displayFormat: 'table',
    isSortable: true,
    isCheckBox: false,
    // "cellContextMenu": true,
    headerContextMenu: true,
    condition: false,
    displayBtnDiv: true,
    exporttoexcel: true,
    isButtonHover: true,
    formSearchBtnAt: 'start',
    cssClass: 'vio-table-bordered',

    headerContextMenuList: [
      {
        label: 'Hide Column',
        action: 'hidecolumn',
      },
      {
        label: 'Display Hidden Columns',
        action: 'displayhiddencols',
      },
      {
        label: 'Freeze Column(s)',
        action: 'freezecolumn',
      },
      {
        label: 'Unfreeze Column',
        action: 'unfreeze',
      },
      {
        label: 'Aggregate',
        action: 'aggregate',
      },
      {
        label: 'Remove Aggregate',
        action: 'removeaggregate',
      },
    ],
    actionButtons: [
      {
        btnName: 'Edit',
        btnTitle: 'Edit',
        btnIcon: 'fa fa-pen',
        btnClass: 'btn-primary mt-1',
      },
      {
        btnName: 'Delete',
        btnTitle: ' Delete',
        btnIcon: 'fa fa-trash',
        btnClass: 'btn-primary mt-1',
      }
    ],
  };
  isSubmitting: boolean = false;
  configs: any[] = [];
  selectedConfig: string = '';
  fromDate: Date | null = null;
  toDate: Date | null = null;
  selectedDevice: string = CONSTS.ALL_DEVICES;
  devicesForConfig: string[] = [];

  showdataTable: boolean = true;

  datatableHeader: TABLE_HEADER[] = [
    { key: 'timestamp', display: 'Time', datatype: 'date', dateFormat: 'YYYY-MMM-DD HH:mm:ss' },
    { key: 'deviceId', display: 'Device Id', datatype: 'string' },

  ]

  datatableData: any[] = [];
  constructor(private ngbModal: NgbModal, public common: CommonFunctionService, private apiRequest: ApiRequestsService) { }

  selectedConfigChanged = (event: any) => {
    console.log('Event of config changed', event);
    let confObj = this.configs.find(c => c.ctName == event);
    this.devicesForConfig = [CONSTS.ALL_DEVICES]
    if (confObj) {
      this.devicesForConfig = [...this.devicesForConfig, ...confObj['devices']]
    }
  }
  getConfigurations = async () => {
    let { errorCode, errorDescription, Data } = await this.apiRequest.postAPICallWithPromise('messageconfig/getConfigurations', { requireDevices: true })

    if (errorCode == this.apiRequest.NO_ERROR) {
      this.configs = [...[{ ctName: '' }], ...Data];
    }
  }

  getData = async () => {
    this.isSubmitting = true;

    if (!this.selectedConfig) {
      this.isSubmitting = false;
      return;
    }
    let fromDate; // = this.fromDate || undefined;
    let toDate; // = this.toDate || undefined;
    if (this.fromDate) {
      fromDate = new Date(this.fromDate).toISOString();
    }
    if (this.toDate) {
      toDate = new Date(this.toDate).toISOString();
    }
    let devices;
    if (this.selectedDevice && this.selectedDevice !== CONSTS.ALL_DEVICES) {
      devices = this.selectedDevice;
    }
    let { errorCode, errorDescription, Data } = await this.apiRequest.postAPICallWithPromise('sensordata/getSensorData', { config: this.selectedConfig, fromDate, toDate, devices });
    if (errorCode == this.apiRequest.NO_ERROR) {
      let { headers, data } = Data;
      this.datatableHeader = headers;
      this.datatableData = data;
    }
    this.isSubmitting = false;
  }

  ngOnInit(): void {
    this.common.pageTitle = 'Data Table';
    this.getConfigurations();

  }
}
